export default __webpack_public_path__ + "static/media/12-min.f50b228f.jpg";